import React from "react";
import { Row, Col, Figure } from "react-bootstrap";
import ExploreProjectImg1 from "../../assets/2.webp";
import mouseLottie from "../../js/mouse-lottie.json";
import Lottie from "lottie-react";
import Footer from "../work/footer";
import { useState, useEffect, useMemo, useContext } from "react";
import axios from "axios";
import WorksDetailsHeader from "./work_details_header";
import { UserContext } from "../../use_context";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

function WorkDetailsMain() {
  const { workData, setWorkData } = useContext(UserContext);
  // const [setWorkData] = useState(null); // ✅ Corrected
  const [mediaData, setMediaData] = useState([]);
  const { categoryId } = useParams();

  console.log("categoryId", categoryId);

  // Set workData from context or fetch from API
  useEffect(() => {
    const fetchWorkData = async () => {
      try {
        const workResponse = await axios.get(`${API_BASE_URL}/work/`);
        console.log("workResponse", workResponse);
        setWorkData(workResponse.data);
      } catch (error) {
        console.error("Failed to fetch work data", error);
      }
    };

    if (!workData || workData.length === 0) {
      fetchWorkData();
    }
  }, [workData]);

  console.log("categoryId:", categoryId);
  console.log("First work item:", workData[0]);
  console.log(
    "Matches:",
    workData?.filter((w) => w["work-category"]?.includes(Number(categoryId)))
  );

  // console.log("workData", workData);

  const filteredWorkData = useMemo(() => {
    return workData?.filter((w) =>
      w["work-category"]?.includes(Number(categoryId))
    );
  }, [workData, categoryId]);

  console.log("filteredWorkData", filteredWorkData);

  // Fetch media for filtered work
  useEffect(() => {
    const fetchMediaData = async () => {
      const fetchedMediaIds = new Set();
      const allMediaData = [];

      for (const work of filteredWorkData) {
        const mediaId = work.featured_media;

        if (!fetchedMediaIds.has(mediaId)) {
          try {
            const response = await axios.get(
              `${API_BASE_URL}/media/${mediaId}`
            );
            allMediaData.push(response.data);
            fetchedMediaIds.add(mediaId);
          } catch (error) {
            console.error("Error fetching media data:", error);
          }
        }
      }
      setMediaData(allMediaData);
    };

    if (filteredWorkData.length > 0) {
      fetchMediaData();
    }
  }, [filteredWorkData]);

  return (
    <React.Fragment>
      <WorksDetailsHeader />
      <main>
        <section
          className="work-detail hero page-hero page-cover hero-fixed hero-overlay-top hero-overlay-bottom lottie-wrapper"
          style={{
            backgroundImage: `url('${
              filteredWorkData.length > 0 && mediaData.length > 0
                ? mediaData[0]?.guid?.rendered || ""
                : ""
            }')`,
          }}
        >
          <div className="text-container">
            <div>
              {filteredWorkData.map((work) => (
                <div key={work.id}>
                  <span className="title-text">{work.title.rendered}</span>
                  <br />
                  <span className="location-text">{work.acf.location}</span>
                </div>
              ))}
            </div>
            {/* <span className="location-text">Alibaugh, Maharashtra</span> */}
          </div>
          {/* <a  className="lottie lottie-mouse absolute">
            <Lottie
              animationData={mouseLottie}
              background="transparent"
              speed="1"
              style={{ width: 100, height: 100 }}
              direction={1}
              loop
              autoplay
            />
          </a> */}
        </section>
        <section className="page-content medium-container" id="project-details">
          <div className="project-meta">
            {filteredWorkData.map((workItem) => (
              <div key={workItem.id}>
                <Row className="text-center">
                  <Col md={12} sm={12}>
                    <dl className="project-location">
                      <dt>Location</dt>
                      <dd>{workItem.acf.location}</dd>
                    </dl>
                  </Col>
                  <Col md={12} sm={12}>
                    <dl className="project-year">
                      <dt>Completion Year</dt>
                      <dd>{workItem.acf.completion_year}</dd>
                    </dl>
                  </Col>
                  <Col md={12} sm={12}>
                    <dl className="project-component">
                      <dt>Project Component</dt>
                      <dd>{workItem.acf.project_component}</dd>
                    </dl>
                  </Col>
                </Row>
              </div>
            ))}
          </div>

          <div className="project-description">
            {/* <div> */}
            {filteredWorkData.map((work) => (
              <div key={work.id}>
                {/* <h2>{work.title.rendered}</h2> */}
                <p
                  className="desc-para"
                  dangerouslySetInnerHTML={{
                    __html: work.content.rendered,
                  }}
                />
              </div>
            ))}
            {/* </div> */}
          </div>

          {/* <ul>
            {filteredWorkData.map((work) => (
              <div key={work.id}>
                <div className="project-meta">
                  <h2 className="section-title">Team</h2>
                  <Row>
                    {work.acf.team_list.map((teamMember, index) => (
                      <Col key={index} md={3} sm={12}>
                        <dl className="project-team">
                          <dt className="project-team-title">
                            {teamMember.title}
                          </dt>
                          <dd className="project-team-def">
                            {teamMember.value}
                          </dd>
                        </dl>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            ))}
          </ul> */}
        </section>
        <section className="project-featured medium-container">
          <h2 className="section-title font-regular text-center ">
            Explore other <strong>featured projects</strong>
          </h2>

          <div className="work-listing grid-col ">
            <a
              href="work-detail.html"
              className="card media-card work-listing-item mix featured"
            >
              <div className="hover-card">
                <Figure className="custom-figure">
                  <Figure.Image
                    src={ExploreProjectImg1}
                    alt="M House, Alibaug"
                    className="figure-image"
                  />
                  <Figure.Caption className="hover-caption">
                    <div>
                      {" "}
                      <div>
                        {" "}
                        <span className="caption-title">M House</span>
                      </div>
                      <div>
                        <span className="caption-location">
                          Alibaug, Maharashtra
                        </span>
                      </div>
                    </div>
                  </Figure.Caption>
                </Figure>
              </div>
            </a>
            <a
              href="work-detail.html"
              className="card media-card work-listing-item mix featured"
            >
              <div className="hover-card">
                <Figure className="custom-figure">
                  <Figure.Image
                    src={ExploreProjectImg1}
                    alt="M House, Alibaug"
                    className="figure-image"
                  />
                  <Figure.Caption className="hover-caption">
                    <div>
                      {" "}
                      <div>
                        {" "}
                        <span className="caption-title">M House</span>
                      </div>
                      <div>
                        <span className="caption-location">
                          Alibaug, Maharashtra
                        </span>
                      </div>
                    </div>
                  </Figure.Caption>
                </Figure>
              </div>
            </a>
            <a
              href="work-detail.html"
              className="card media-card work-listing-item mix featured"
            >
              <div className="hover-card">
                <Figure className="custom-figure">
                  <Figure.Image
                    src={ExploreProjectImg1}
                    alt="M House, Alibaug"
                    className="figure-image"
                  />
                  <Figure.Caption className="hover-caption">
                    <div>
                      {" "}
                      <div>
                        {" "}
                        <span className="caption-title">M House</span>
                      </div>
                      <div>
                        <span className="caption-location">
                          Alibaug, Maharashtra
                        </span>
                      </div>
                    </div>
                  </Figure.Caption>
                </Figure>
              </div>
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </React.Fragment>
  );
}

export default WorkDetailsMain;
